/* eslint-disable import/no-unresolved */
import React from 'react';

import RightModalLayout from '../../../../../../../../layouts/Modal/RightModalLayout';
import DropdownMC from '../../../../../../../../components/DropdownMC';

const AssignToTeamToolView = ({
  t,
  footerSubmitLabel,
  handleBack,
  handleConfirmAssignment,
  teamOptions,
  selectedTeam,
  setSelectedTeam
}) => (
  <RightModalLayout
    closeAction={handleBack}
    title={t('tools.assign_to_team_title')}
    showBackButton
    submitLabel={footerSubmitLabel}
    submitAction={handleConfirmAssignment}
    cancelLabel={t('Common:actions.cancel')}
    cancelAction={handleBack}
    footerVariant="VERTICAL"
  >
    <div className="tw-flex tw-flex-col tw-gap-4">
      <DropdownMC
        id="team_id"
        name="team_id"
        label={t('tools.team_label')}
        placeholder={t('tools.select_placeholder')}
        options={teamOptions}
        onSelect={setSelectedTeam}
        defaultValue={selectedTeam}
        useFloatingLabel
      />
    </div>
  </RightModalLayout>
);

export default AssignToTeamToolView;
